import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { Subscription } from 'rxjs'
import { ICustomProduct } from '../../../models/ICustomProduct'
import { CompareProductsService } from './compare-products.service'

@Directive({
  selector: '[appCompare]',
  standalone: false
})
export class CompareProductsDirective implements OnInit, OnDestroy {
  @Input('productToCompare') productToCompare: ICustomProduct
  private subscription = new Subscription()

  constructor(
    private element: ElementRef,
    private matSlideToggle: MatSlideToggle,
    private compareProductsService: CompareProductsService
  ) {}

  ngOnInit(): void {
    //handle removal of product from outside component (app-action-button)
    this.subscription.add(
      this.compareProductsService.getCompareProductsList().subscribe((products) => {
        if (!products.includes(this.productToCompare)) {
          this.matSlideToggle.checked = false
          this.element.nativeElement.childNodes[0].childNodes[1].textContent = 'Add to compare'
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  @HostListener('change')
  onChange() {
    const isChecked = this.matSlideToggle.checked

    //find and set mat-toggle label
    this.element.nativeElement.childNodes[0].childNodes[1].textContent = isChecked ? 'Remove compare' : 'Add to compare'

    if (isChecked) {
      this.compareProductsService.addProductToCompare(this.productToCompare)
    } else {
      this.compareProductsService.removeProductFromCompare(this.productToCompare)
    }
  }
}
